module.exports = __webpack_public_path__ + "static/media/loginLogo.b7f4a6d6.png";